export const inputStyles = {
  window: {
    overflowY: "auto",
    justifyContent: "stretch",
    alignItems: "flex-start",
  },
  frame: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    padding: "0px",
    outline: "none",
  },
  lineInput: {
    outline: "none",
    border: "none",
    width: "100%",
    margin: "0",
    shadow: "none",
  },
  lineBar: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
    borderWidth: "0px",
    paddingRight: 5,
    width: 50,
    borderStyle: "solid",
    borderColor: "white",
  },
  lineNumber: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    paddingRight: 5,
    background: "black",
    color: "white",
  },
  bottomBar: {
    height: 30,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
};
